import { defineStore } from 'pinia';

export const useSenderFormStore = defineStore({
  id: 'senderForm',
  state: () => ({
    addressCargoPickup: null,
    detailsPickup: '',
    pickupDate: '',
    cargoTimePickup: '',
    comment: '',
    whoPaysZabor: '',
    typeOfPaymentZabor: '',
    powerOfAttorney: '',
    typePowerOfAttorney: '',
    dataForTheDriver: '',
    sendTo: '',
  }),
});
